import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {LabelToken} from '@github-ui/label-token'
import {useRouteParams} from '@github-ui/react-core/future/use-route-params'
import {pullRequestsOverviewRoute} from '../../routes/overview-route'
import type {PullRequestLabel as Label} from '@github-ui/dotcom-schema/types/pull_requests/v1/labels'
import {useLabels} from './data/use-labels'
import styles from './Labels.module.css'

export function Labels() {
  return (
    <ErrorBoundary boundaryName="Labels" fallback={<span className={styles.emptyState}>Unable to load labels</span>}>
      <Suspense fallback={<span className={styles.emptyState}>Loading...</span>}>
        <LabelsContent />
      </Suspense>
    </ErrorBoundary>
  )
}

function LabelsContent() {
  const {
    data: {labels},
  } = useLabels()
  if (!labels || labels.length === 0) {
    return <span className={styles.emptyState}>None yet</span>
  }
  return <LabelList labels={labels} />
}

function LabelList({labels}: {labels: Label[]}) {
  const {owner, repo} = useRouteParams(pullRequestsOverviewRoute)
  return (
    <ul className={styles.labelList}>
      {labels.map(label => (
        <li key={label.id} className={styles.labelItem}>
          <LabelRow label={label} owner={owner} repo={repo} />
        </li>
      ))}
    </ul>
  )
}

function LabelRow({label, owner, repo}: {label: Label; owner: string; repo: string}) {
  const href = `/${owner}/${repo}/issues?q=${encodeURIComponent(`state:open label:"${label.name}"`)}`
  return (
    <LabelToken
      as="a"
      href={href}
      text={label.name}
      fillColor={`#${label.color}`}
      title={label.description || undefined}
    />
  )
}
